import { useEffect, useState } from "react";
import useAxios from "../../../../hooks/useAxios";
import Constants from "../../../../Constants";
import { getDashboardFilterQueryString } from "../../../../utils/helper";
import { useCompanyFilterContext } from "../../components/context/CompanyFilterContext";

export const useCompanySubscriptionsCredit = () => {
    const { filterParams } = useCompanyFilterContext();
    const { selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies } = filterParams;
    const { getData, isLoading } = useAxios();

    const [rollOverCreditAnalytics, setRollOverCreditAnalytics] = useState([]);
    const [alaCarteCreditAnalytics, setAlaCarteCreditAnalytics] = useState([]);

    useEffect(() => {
        const fetchRollOverCredits = async () => {
            const baseUrl = Constants.ApiUrl.super.dashboard;
            const subscriptionKey = "rollOverCredits";
            const query = getDashboardFilterQueryString({ selectedRange, selectedTiers, selectedStatus, subscriptionKey, selectedAccountExecutive, selectedCompanies });
            try {
                const response = await getData(`${baseUrl.getSubscriptionAnalytics}?${query}`);
                if (response?.success) {
                    setRollOverCreditAnalytics(response?.data || []);
                }
            } catch (err) {
                console.error("Failed to fetch inactive companies", err);
                setRollOverCreditAnalytics([]);
            }
        };

        fetchRollOverCredits();
    }, [selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies]);

    useEffect(() => {
        const fetchAlaCarteCredits = async () => {
            const baseUrl = Constants.ApiUrl.super.dashboard;
            const subscriptionKey = "totalAlaCarteCases";
            const query = getDashboardFilterQueryString({ selectedRange, selectedTiers, selectedStatus, subscriptionKey, selectedAccountExecutive, selectedCompanies });
            try {
                const response = await getData(`${baseUrl.getSubscriptionAnalytics}?${query}`);
                if (response?.success) {
                    setAlaCarteCreditAnalytics(response?.data || []);
                }
            } catch (err) {
                console.error("Failed to fetch ala carte credits", err);
                setAlaCarteCreditAnalytics([]);
            }
        };

        fetchAlaCarteCredits();
    }, [selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies]);

    return {
        isSubscriptionLoading: isLoading,
        rollOverCreditAnalytics,
        alaCarteCreditAnalytics
    };
};
